export default function PHP_Multidimensional_Arrays() {
  return (
    <div>
      <h1>PHP_Multidimensional_Arrays</h1>
    </div>
  );
}
